import {
  requestImmediateDataFlush,
  logCustomEvent,
  isInitialized,
} from "@braze/web-sdk";
import { IGeolocation } from "@origin-digital/event-dispatcher";

const INTERVAL_CHECK_MS = 2000;
const MAX_WAIT_TIME_MS = 10000;
export const EVENT_NAME = "web::trigger::geolocation::updated";

export const syncBrazeSdkUserGeolocation = (
  geolocation: IGeolocation
): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!geolocation.state) {
      return resolve(false);
    }

    // eslint-disable-next-line prefer-const
    let intervalId: any;
    const waitToLogEvent = () => {
      if (isInitialized()) {
        const isEventLogged = logCustomEvent(EVENT_NAME, {
          state: geolocation.state,
        });
        requestImmediateDataFlush();
        intervalId = clearInterval(intervalId);
        resolve(isEventLogged);
      }
    };
    intervalId = setInterval(waitToLogEvent, INTERVAL_CHECK_MS);
    setTimeout(() => {
      if (intervalId) {
        clearInterval(intervalId);
        resolve(false);
      }
    }, MAX_WAIT_TIME_MS);
  });
};
